import React from 'react'
import { Box, Chip, Tooltip } from '@mui/material'
import { Lock } from '@mui/icons-material'

export interface WebinarCategoryChipsProps {
  selectedCategory: string | null
  groupedWebinarTypes: string[]
  isCategoryAccessible: (category: string) => boolean
  onCategorySelect: (category: string | null) => void
  onLockedCategoryClick?: (category: string) => void
}

const WebinarCategoryChips: React.FC<WebinarCategoryChipsProps> = ({
  selectedCategory,
  groupedWebinarTypes,
  isCategoryAccessible,
  onCategorySelect,
  onLockedCategoryClick,
}) => {
  const handleCategoryClick = (category: string) => {
    if (isCategoryAccessible(category)) {
      onCategorySelect(selectedCategory === category ? null : category)
    } else if (onLockedCategoryClick) {
      onLockedCategoryClick(category)
    }
  }

  return (
    <Box sx={{ mb: 2, mt: 1 }}>
      <Chip
        label="All"
        variant={selectedCategory === null ? 'filled' : 'outlined'}
        onClick={() => onCategorySelect(null)}
        sx={{ mr: 1, mb: 1 }}
        color={selectedCategory === null ? 'primary' : 'default'}
      />
      {groupedWebinarTypes.map((nickname) => {
        const isAccessible = isCategoryAccessible(nickname)
        const isSelected = selectedCategory === nickname

        const chipSx = {
          mr: 1,
          mb: 1,
          ...(!isAccessible && {
            opacity: 0.7,
            '&:hover': {
              opacity: 0.9,
              cursor: 'pointer',
            },
          }),
        }

        return (
          <Tooltip
            key={nickname}
            title={isAccessible ? '' : 'Upgrade your membership to access this content'}
          >
            <span>
              <Chip
                label={
                  isAccessible ? (
                    nickname
                  ) : (
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <Lock fontSize="small" />
                      {nickname}
                    </Box>
                  )
                }
                variant={isSelected ? 'filled' : 'outlined'}
                onClick={() => handleCategoryClick(nickname)}
                color={isSelected ? 'primary' : 'default'}
                sx={chipSx}
              />
            </span>
          </Tooltip>
        )
      })}
    </Box>
  )
}

export default WebinarCategoryChips
